module.exports = __webpack_public_path__ + "static/media/goodnest3_preview.4bfdc91a.jpg";